import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊' },
    { path: '/admin/users', label: 'User Management', icon: '👥' },
    { path: '/admin/compliance', label: 'Compliance', icon: '🛡️' },
    { path: '/admin/data-retention', label: 'Data Retention', icon: '🗂️' },
    { path: '/admin/reports', label: 'Reports', icon: '📈' },
  ];

  return (
    <div className="admin-layout">
      <div className="admin-header">
        <div className="admin-header-content">
          <div className="admin-brand">
            <h1>Admin Panel</h1>
          </div>
          <div className="admin-user-info">
            <span>Administrator</span>
            <Link to="/" className="back-to-app">← Back to App</Link>
          </div>
        </div>
      </div>

      <div className="admin-container">
        <nav className="admin-sidebar">
          <ul className="admin-nav">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`admin-nav-link ${
                    location.pathname === item.path ? 'active' : ''
                  }`}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;